import { useState } from 'react';
import { testimonials } from '@/mocks/comics';

export default function Testimonials() {
  const [current, setCurrent] = useState(0);
  const t = testimonials[current];

  const prev = () => {
    setCurrent((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const next = () => {
    setCurrent((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="py-14 md:py-20 bg-background-100/70">
      <div className="mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
            读者
            <span className="font-serif italic font-normal text-foreground-400">口碑</span>
          </h2>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="relative bg-background-50 rounded-2xl p-6 md:p-10">
            <div className="flex items-center gap-2 mb-6">
              <div className="flex gap-0.5">
                {[...Array(t.rating)].map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-400 text-sm"></i>
                  </div>
                ))}
              </div>
              <span className="px-2.5 py-0.5 bg-background-900 text-white text-xs font-medium rounded-full whitespace-nowrap">
                {t.rating}.0
              </span>
            </div>

            <blockquote className="text-foreground-700 text-base md:text-lg leading-relaxed mb-8 font-serif italic">
              &ldquo;{t.text}&rdquo;
            </blockquote>

            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
              </div>
              <div>
                <div className="text-foreground-900 font-medium text-sm">{t.name}</div>
                <div className="text-foreground-400 text-xs">{t.role}</div>
              </div>
            </div>

            <div className="absolute bottom-6 right-6 md:bottom-10 md:right-10 flex gap-2">
              <button
                onClick={prev}
                className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-300 bg-background-50 hover:bg-background-100 text-foreground-600 transition-colors cursor-pointer"
                aria-label="上一条评价"
              >
                <i className="ri-arrow-left-s-line"></i>
              </button>
              <button
                onClick={next}
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-900 hover:bg-background-800 text-white transition-colors cursor-pointer"
                aria-label="下一条评价"
              >
                <i className="ri-arrow-right-s-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}